import { render } from "./PopulationForm.vue?vue&type=template&id=061a37ec"
import script from "./PopulationForm.vue?vue&type=script&lang=js"
export * from "./PopulationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__